import { useContext, useEffect, useId, useMemo } from 'react'
import debounce from 'lodash.debounce'
import { DevPanelDispatchContext } from './DevPanelContext'
import noop from 'lib/function/noop'

export function useReportContextToDevPanel(name: string, value: any) {
  const devPanelDispatch = useContext(DevPanelDispatchContext)
  const id = useId()

  const debouncedDevPanelDispatch = useMemo(() => (
    devPanelDispatch === noop ? noop : debounce(devPanelDispatch, 200)
  ), [devPanelDispatch])

  useEffect(() => {
    debouncedDevPanelDispatch({
      type: 'reportContext',
      context: { id, name, value },
    })
  }, [debouncedDevPanelDispatch, id, name, value])

  useEffect(() => {
    return () => {
      devPanelDispatch({
        type: 'removeContext',
        id,
      })
    }
  }, [devPanelDispatch, id])
}
